import { useQuery } from '@tanstack/react-query';
import { fetchCommunicationCategoryCounts } from '../services/communicationCategoryCounts';
import {
    COMMUNICATION_CATEGORY_COUNTS_GLOBAL_KEY,
    COMMUNICATION_CATEGORY_COUNTS_KEY
} from './queryKeys';

// The Overview tab only mounts CommunicationsByCategoryCard (and therefore
// this hook) while it's the active tab - mounting IS the "tab is active"
// signal, same gating as the rest of the tab's queries.
export function useCommunicationCategoryCounts(practiceId: string | undefined, days: number) {
    const query = useQuery({
        queryKey: COMMUNICATION_CATEGORY_COUNTS_KEY(practiceId ?? '', days),
        queryFn: () => fetchCommunicationCategoryCounts(days, practiceId as string),
        enabled: Boolean(practiceId),
        staleTime: 60_000
    });

    return {
        counts: query.data ?? [],
        isLoading: query.isLoading,
        isError: query.isError
    };
}

// Global (no practice filter) variant for the Accounts Overview hub's
// "Communications by category" card - always enabled, unlike the
// practice-scoped hook above which waits on a real practiceId.
export function useGlobalCommunicationCategoryCounts(days: number) {
    const query = useQuery({
        queryKey: COMMUNICATION_CATEGORY_COUNTS_GLOBAL_KEY(days),
        queryFn: () => fetchCommunicationCategoryCounts(days),
        staleTime: 60_000
    });

    return {
        counts: query.data ?? [],
        isLoading: query.isLoading,
        isError: query.isError,
        refetch: query.refetch
    };
}
